import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router';
import useAuth from '../hooks/useAuth';
import {
  LogoutOutlined,
  ProjectOutlined,
  EditOutlined,
  CompassOutlined,
  BranchesOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import { Layout, Menu, Button, theme, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { useLogoutFunction } from '@propelauth/react';

const { Header, Sider, Content } = Layout;

const AppLayout: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer }
  } = theme.useToken();

  const getDefaultSelectedKey = () => {
    const pathSegments = pathname.split('/');
    const currentKey = pathSegments[1];
    const validKeys = [
      'projects',
      'shared-content',
      'locations',
      'project_types',
      'ghg_standards',
      'proponents',
      'carbon-indices',
      'compass-modules',
      'project-type-mapper',
      'location-mapper',
      'generic-project-type-mapper',
      'generic-location-mapper',
      'market-indicator-mitigation-mapper',
      'mitigation-type-mapper',
      'corsia-catcher'
    ];
    return validKeys.includes(currentKey) ? [currentKey] : ['projects'];
  };

  const onMenuItemClick = ({ key }) => {
    navigate(key);
  };

  const logoutFunction = useLogoutFunction();
  const onLogout = async () => {
    await logoutFunction(false);
  };

  return (
    <Layout hasSider>
      <Sider
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <Link to='/'>
          <div className='text-white text-xl font-semibold logo m-2 ml-4 my-5 whitespace-nowrap overflow-clip'>
            Calyx Global
          </div>
        </Link>
        <Menu
          theme="dark"
          mode="inline"
          onClick={onMenuItemClick}
          defaultSelectedKeys={getDefaultSelectedKey()}
          items={[
            {
              key: 'projects',
              icon: <ProjectOutlined />,
              label: <Tooltip title="Projects" placement="right">Projects</Tooltip>
            },
            {
              key: 'shared-content',
              icon: <EditOutlined />,
              label: <Tooltip title="Shared Content" placement="right">Shared Content</Tooltip>
            },
            {
              key: 'locations',
              icon: <EditOutlined />,
              label: <Tooltip title="Locations" placement="right">Locations</Tooltip>
            },
            {
              key: 'project_types',
              icon: <EditOutlined />,
              label: <Tooltip title="Project Types" placement="right">Project Types</Tooltip>
            },
            {
              key: 'ghg_standards',
              icon: <EditOutlined />,
              label: <Tooltip title="Methodology and Registry" placement="right">Methodology and Registry</Tooltip>
            },
            {
              key: 'proponents',
              icon: <EditOutlined />,
              label: <Tooltip title="Proponents" placement="right">Proponents</Tooltip>
            },
            {
              key: 'carbon-indices',
              icon: <LineChartOutlined />,
              label: <Tooltip title="Carbon Indices" placement="right">Carbon Indices</Tooltip>
            },
            {
              key: 'compass-modules',
              icon: <CompassOutlined />,
              label: <Tooltip title="Compass Modules" placement="right">Compass Modules</Tooltip>
            },
            {
              key: 'project-type-mapper',
              icon: <BranchesOutlined />,
              label: <Tooltip title="Project Type Mapper" placement="right">Project Type Mapper</Tooltip>
            },
            {
              key: 'location-mapper',
              icon: <BranchesOutlined />,
              label: <Tooltip title="Location Mapper" placement="right">Location Mapper</Tooltip>
            },
            {
              key: 'generic-project-type-mapper',
              icon: <BranchesOutlined />,
              label: <Tooltip title="Generic Project Type Mapper" placement="right">Generic Project Type Mapper</Tooltip>
            },
            {
              key: 'generic-location-mapper',
              icon: <BranchesOutlined />,
              label: <Tooltip title="Generic Location Mapper" placement="right">Generic Location Mapper</Tooltip>
            },
            {
              key: 'market-indicator-mitigation-mapper',
              icon: <BranchesOutlined />,
              label: <Tooltip title="Market labels Mapper" placement="right">Market labels Mapper</Tooltip>
            },
            {
              key: 'mitigation-type-mapper',
              icon: <BranchesOutlined />,
              label: <Tooltip title="Mitigation Type Mapper" placement="right">Mitigation Type Mapper</Tooltip>
            },
            {
              key: 'corsia-catcher',
              icon: <EditOutlined />,
              label: <Tooltip title="CORSIA Catcher" placement="right">CORSIA Catcher</Tooltip>
            },
          ]}
        />
        <div className='absolute bottom-0 w-full'>
          <Button
            type='default'
            onClick={onLogout}
            className='w-full'
            danger
          >
            <LogoutOutlined />
            Logout
          </Button>
        </div>
      </Sider>
      <Layout className='min-h-screen' style={{ marginLeft: 200 }}>
        <Outlet />
      </Layout>
    </Layout>
  );
};

export default AppLayout;
